<template>
  <div class="main">
       <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="equipMenu" current="车型对比"  />
      <xy-toolbox-menu class="r"  >
        <xy-toolbox-menu-item icon="car_search" @click="gocompare">返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <xy-toolbox-menu>
      <xy-toolbox-menu-item custom>
        <div class="custom-content">
          <el-select v-model="viewValue" placeholder="选择显示形式" @change="changeViewOption">
            <el-option
              v-for="item in viewOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </xy-toolbox-menu-item>
      
    </xy-toolbox-menu>
    <el-tabs type="border-card">
      <el-tab-pane
        v-for="p of pklist"
        :key="p.id"
        :label="p.title"
        :title="p.title"
        v-html="p.content"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<style>
</style>

<script>
const OptionPattern = /\(选装:(.*?)\)/g;
const HasDigit = /\d+/;
import { mapMutations, mapGetters, mapActions } from "vuex";
import SearchBar from "@/components/common/EquipSearch.vue";
import Permissions from  '../../store/permissions.js'
import { formatDate, strToFormatDate } from "@/plugins/DateTimeFormater.js";
import XLSX from "xlsx";
export default {
  name: "equippk1",
  data() {
    return {
      categories: [],
      pklist: [],
      pkids: [],
      paramData: [],
      lines: [],
      excelData: [],
      viewValue: 1,
      viewOptions: [
        {
          value: 1,
          label: "显示全部"
        },
        {
          value: 2,
          label: "仅显示相同"
        },
        {
          value: 3,
          label: "仅显示优劣势"
        }
      ]
    };
  },
  methods: {
    ...mapActions("equipanalysis", ["queryEquipParams"]),
    async queryData() {
      var postData = {
        ids: this.pkids
      };
      this.queryEquipParams({
          params: postData
        });
    },
    test() {},
    changeViewOption() {
      this.bindData();
    },
    gocompare() {
      this.$router.push({
        name: "equipcompare"
      });
    },
    bindData() {
      this.margeEquip();
      this.pklist.forEach(x => {
        this.makeContent(x);
      });
    },
    margeEquip() {
      var margeKeys = ["钥匙", "科技"];
      var filterKeys = ["参数", "动力"];
      var margeName = margeKeys.join(" & ");
      this.paramData = [];
      this.categories = [];
      this.lines = this.equipParamsList.lines;
      for (const item of this.equipParamsList.categories) {
        if (filterKeys.findIndex(x => x == item.name) > -1) {
          continue;
        }
        if (margeKeys.findIndex(x => x == item.name) > -1) {
          continue;
        }
        this.categories.push(item);
      }
      this.categories.push({ id: -1, name: margeName });
      for (const item of this.equipParamsList.dataDict) {
        if (filterKeys.findIndex(x => x == item.tag) > -1) {
          continue;
        }

        if (margeKeys.findIndex(x => x == item.tag) > -1) {
          this.paramData.push({
            name: item.name,
            val: item.val,
            tag: margeName,
            lines: item.lines
          });
        } else {
          this.paramData.push(item);
        }
      }
      //alert(JSON.stringify(this.paramData));
    },
    makeContent(x) {
      var cats = this.categories;
      var catlen = cats.length + 1;
      var pk1a_name = this.lines.find(item => item.id == x.p0);
      var pk2a_name = this.lines.find(item => item.id == x.p1);
      var pk1a_title = pk1a_name.name;
      var pk2a_title = pk2a_name.name;
      if (pk1a_name.msrp && pk1a_name.msrp > 0) {
        pk1a_title += "(MSRP:" + pk1a_name.msrp + ")";
      }
      if (pk1a_name.price && pk1a_name.price > 0) {
        pk1a_title += "(price:" + pk1a_name.price + ")";
      }
      if (pk2a_name.msrp && pk2a_name.msrp > 0) {
        pk2a_title += "(MSRP:" + pk2a_name.msrp + ")";
      }
      if (pk2a_name.price && pk2a_name.price > 0) {
        pk2a_title += "(price:" + pk2a_name.price + ")";
      }
      var html = ' <div class="pk1box">';
      html += "<h3>" + pk1a_title + "</h3> ";
      var pk1a = this.find_line(x.p0);
      var pk2a = this.find_line(x.p1);
      html +=
        ' <div class="pk-content" style="grid-template-columns: ' +
        " auto".repeat(catlen) +
        ';">';
      //第一列分类
      for (var i = 0; i < catlen; i++) {
        if (i == 0) {
          html += ' <div class="item"> </div>';
        } else {
          html += ' <div class="item">' + cats[i - 1].name + "</div>";
        }
      }
      //优势
      if (this.viewValue == 1 || this.viewValue == 3) {
        for (var i = 0; i < catlen; i++) {
          if (i == 0) {
            html +=
              ' <div class="item goodness"> ' +
              pk1a_name.name +
              "优势装备  </div>";
          } else {
            html +=
              ' <div class="item">' +
              this.pk(pk1a, pk2a, cats[i - 1].name, 1) +
              "</div>";
          }
        }
      }
      if (this.viewValue == 1 || this.viewValue == 2) {
        for (var i = 0; i < catlen; i++) {
          if (i == 0) {
            html += ' <div class="item gy">  共有装备  </div>';
          } else {
            html +=
              ' <div class="item">' +
              this.pk(pk1a, pk2a, cats[i - 1].name, 2) +
              "</div>";
          }
        }
      }
      if (this.viewValue == 1 || this.viewValue == 3) {
        for (var i = 0; i < catlen; i++) {
          if (i == 0) {
            html +=
              ' <div class="item goodness"><div class="gy">  ' +
              pk2a_name.name +
              "优势装备 </div>   </div>";
          } else {
            html +=
              ' <div class="item">' +
              this.pk(pk2a, pk1a, cats[i - 1].name, 1) +
              "</div>";
          }
        }
      }
      for (var i = 0; i < catlen; i++) {
        if (i == 0) {
          html += ' <div class="item"> </div>';
        } else {
          html += ' <div class="item">' + cats[i - 1].name + "</div>";
        }
      }
      html += "</div>";
      html += "<h3>" + pk2a_title + "</h3>";
      html += "</div> ";
      x.content = html;
    },
    //1优势装备 ，2 共有
    pk(equip1, equip2, cat, type) {
      var list = [];
      var clsName = "ls-goodness";
      if (type == 2) {
        clsName = "ls-public";
      } else if (type == 3) {
        clsName = "ls-inferior";
      }
      var html = "";
      var html = '<ul class="' + clsName + '">';
      equip1.forEach(x => {
        if (x.tag == cat) {
          if (type == 1) {
            var fd = equip2.find(item => item.name == x.name);
            if (!fd || fd.val != x.val) {
              if (!HasDigit.test(x.val)) {
                html += "<li>" + x.val + " </li>";
              } else {
                html += "<li> " + x.name + ":" + x.val + "</li> ";
              }
            }
          } else if (type == 2) {
            var fd = equip2.find(item => item.name == x.name);
            if (fd && fd.val == x.val) {
              if (!HasDigit.test(x.val)) {
                html += "<li>" + x.val + " </li>";
              } else {
                html += "<li> " + x.name + ":" + x.val + "</li> ";
              }
            }
          }
        }
      });
      html += "</ul> ";
      return html;
    },
    find_line(id) {
      var result = [];
      var opts = [];
      var aaa;
      for (var i = 0; i < this.paramData.length; i++) {
        var r = this.paramData[i];
        for (var j in r.lines) {
          if (j == id) {
             var val = r.lines[j].replace(OptionPattern,'');
            if (val != "-" && val !='') {
              var line = {
                id: id,
                tag: r.tag,
                name: r.name,
                val: val
              };
              result.push(line);
            }
          }
        }
      }
      return result;
    },
       getNowFormatDate() {
        var date = new Date();
        var seperator1 = "";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    exportExcel(){
        
        //  if(!Permissions.Client_ViewLine_LineEq_Down())
        //     {
        //        this.$message({ message: "没有下载权限。", duration: 2000 });
        //        return ;
        //     }
        for(const x of this.pklist)
        {
              var excelData = [];   
              this.make_excel_sheet(x ,excelData);
              JSONToExcel(excelData, x.title, x.title);
       
        }
    },
     make_excel_sheet(x,excelData) {
      var cats = this.categories;
      var catlen = cats.length + 1;
      var pk1a_name = this.lines.find(item => item.id == x.p0);
      var pk2a_name = this.lines.find(item => item.id == x.p1);
      var pk1a_title = pk1a_name.name;
      var pk2a_title = pk2a_name.name;
      if (pk1a_name.msrp && pk1a_name.msrp > 0) {
        pk1a_title += "(MSRP:" + pk1a_name.msrp + ")";
      }
      if (pk1a_name.price && pk1a_name.price > 0) {
        pk1a_title += "(price:" + pk1a_name.price + ")";
      }
      if (pk2a_name.msrp && pk2a_name.msrp > 0) {
        pk2a_title += "(MSRP:" + pk2a_name.msrp + ")";
      }
      if (pk2a_name.price && pk2a_name.price > 0) {
        pk2a_title += "(price:" + pk2a_name.price + ")";
      }
      var html =' ';
 
      var pk1a = this.find_line(x.p0);
      var pk2a = this.find_line(x.p1);
   
      //第一列分类
      var r1= {};
      for (var i = 0; i < catlen; i++) {
        if (i == 0) {
          r1["_"] = '';
        } else {
          r1[cats[i - 1].name] =cats[i - 1].name ;
        }
      }
      excelData.push(r1);
      //优势
    
      if (this.viewValue == 1 || this.viewValue == 3) {
          var r2={};
        for (var i = 0; i < catlen; i++) {
          if (i == 0) {
                r2["_"] =  pk1a_title +'优势装备 ';
          } else {
                r2[cats[i - 1].name]=  this.pk(pk1a, pk2a, cats[i - 1].name, 1);
          }
        }
           excelData.push(r2);
      }
   

      if (this.viewValue == 1 || this.viewValue == 2) {
        var r3 ={};
        for (var i = 0; i < catlen; i++) {
          if (i == 0) {
            r3['_'] ='共有装备';
          } else {
            r3[cats[i - 1].name] = this.pk(pk1a, pk2a, cats[i - 1].name, 2);
          }
        }
         excelData.push(r3);
      }
      if (this.viewValue == 1 || this.viewValue == 3) {
        var r4 = {};
        for (var i = 0; i < catlen; i++) {
          if (i == 0) {
              r4['_'] = pk2a_title + "优势装备";
          } else {
            
              r4[cats[i - 1].name] =this.pk(pk2a, pk1a, cats[i - 1].name, 1) ;
          }
        }
           excelData.push(r4);
      }

      var r5 ={};
      for (var i = 0; i < catlen; i++) {
        if (i == 0) {
          r5['_'] = '';
        } else {
        
            r5[cats[i - 1].name] = cats[i - 1].name ;
        }
      }
  excelData.push(r5);
     
    },
    //1优势装备 ，2 共有
    pk(equip1, equip2, cat, type) {
      var list = [];
      var clsName = "ls-goodness";
      if (type == 2) {
        clsName = "ls-public";
      } else if (type == 3) {
        clsName = "ls-inferior";
      }
      var html = "";
      var html = '<ul class="' + clsName + '">';
      equip1.forEach(x => {
        if (x.tag == cat) {
          if (type == 1) {
            var fd = equip2.find(item => item.name == x.name);
            if (!fd || fd.val != x.val) {
              if (!HasDigit.test(x.val)) {
                html += "<li>" + x.val + " </li>";
              } else {
                html += "<li> " + x.name + ":" + x.val + "</li> ";
              }
            }
          } else if (type == 2) {
            var fd = equip2.find(item => item.name == x.name);
            if (fd && fd.val == x.val) {
              if (!HasDigit.test(x.val)) {
                html += "<li>" + x.val + " </li>";
              } else {
                html += "<li> " + x.name + ":" + x.val + "</li> ";
              }
            }
          }
        }
      });
      html += "</ul> ";
      return html;
    },
  },
  mounted() {
    var params = this.$route.params.q;
    if (params == undefined) {
      return;
    }
    var ids = new Set();
    this.pklist.length = 0;
    params.forEach(x => {
      var title = "..." + x[0].name.substring(x[0].name.length - 5) +" VS " +"..." + x[1].name.substring(x[1].name.length - 5);
      this.pklist.push({
        title: title,
        p0: x[0].carId,
        p1: x[1].carId,
        id: "p" + x[0].carId + "_" + x[1].carId,
        content: '    <div class="item goodness">loading ... </div>'
      });
      ids.add(x[0].carId);
      ids.add(x[1].carId);
    });
    this.pkids = [...ids];
    this.queryData();
  },
  computed: {
    ...mapGetters("equipanalysis", {
      equipParamsList: "equipParamsList"
    })
  },
  watch: {
    equipParamsList(value) {
      this.bindData();
    }
  }
};
</script>

